/* eslint-disable react/jsx-props-no-spreading */
import type { SVGProps } from 'react';

const defaultWidth = 32;
const defaultHeight = 32;

type SvgProps = SVGProps<SVGSVGElement> & {
  width?: number;
  height?: number;
  color?: string;
};

export const ZenithLogoIcon = ({ width = defaultWidth, height = defaultHeight, color = '#564599' }: SvgProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 32 32" fill="none">
      <path
        d="M19.9852 0H12.0099C5.37608 0 0 5.37608 0 12.0099V19.9852C0 26.619 5.37608 31.9951 12.0099 31.9951H19.9852C26.619 31.9951 31.9951 26.619 31.9951 19.9852V12.0099C31.9951 5.37608 26.619 0 19.9852 0Z"
        fill="#040000"
      />
      <mask
        id="mask0_792_10771"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width={width}
        height={height}
      >
        <path
          d="M19.9901 0H12.0147C5.38188 0 0.00488281 5.377 0.00488281 12.0099V19.9852C0.00488281 26.6181 5.38188 31.9951 12.0147 31.9951H19.9901C26.623 31.9951 32 26.6181 32 19.9852V12.0099C32 5.377 26.623 0 19.9901 0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_792_10771)">
        <path
          d="M16.0641 44.1084C34.1997 44.1084 48.9025 38.6485 48.9025 31.9112C48.9025 25.1738 34.1997 19.7139 16.0641 19.7139C-2.07158 19.7139 -16.7744 25.1738 -16.7744 31.9112C-16.7744 38.6485 -2.07158 44.1084 16.0641 44.1084Z"
          fill="url(#paint0_radial_792_10771)"
        />
      </g>
      <path
        d="M16.252 5.64277C14.9154 5.64277 13.7119 5.87952 12.6367 6.34808C10.3186 7.38383 9.61328 9.26793 9.61328 9.26793C10.9351 9.44055 12.2323 9.6921 13.485 10.0226C13.485 10.0226 14.146 9.08051 16.2619 9.10023C17.273 9.1101 18.1558 9.37644 18.8956 9.92884C19.6453 10.4812 20.2471 11.1915 20.7058 12.0694L23.8772 10.4664C21.49 5.31725 16.252 5.64277 16.252 5.64277Z"
        fill="white"
      />
      <path
        d="M23.9454 20.567C23.9454 18.9246 23.4374 17.6373 22.4214 16.7002C16.7789 11.6842 9.18338 11.1367 9.18338 11.1367C9.18338 11.1367 8.93184 14.5202 12.4386 15.625C14.6186 16.2415 16.5866 17.1293 18.2241 18.2193C18.6778 18.5202 19.1119 18.8359 19.5114 19.1663C19.9109 19.4968 20.1674 20.0196 20.1674 20.5523V20.567C20.1674 21.3118 19.8468 21.8889 19.2056 22.2933C18.5644 22.6978 17.6371 22.9 16.4337 22.9C15.2302 22.9 14.2093 22.5942 13.3215 21.9875C12.4337 21.3809 11.7432 20.5424 11.2598 19.4672L8.03418 21.0751C8.71975 22.7471 9.7851 24.0442 11.2302 24.9666C12.6754 25.8889 14.4164 26.3574 16.4337 26.3574C17.8492 26.3574 19.1267 26.1306 20.266 25.662C21.3609 25.2181 22.2241 24.5769 22.8702 23.7631C24.0046 22.3673 23.9454 20.567 23.9454 20.567Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_792_10771"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.1846 30.8596) rotate(90) scale(12.2893 33.0876)"
        >
          <stop stopColor={color} />
          <stop offset="1" stopColor="#040000" />
        </radialGradient>
      </defs>
    </svg>
  );
};

ZenithLogoIcon.displayName = 'ZenithLogoIcon';
